export const environment = {
  baseEndpoint: 'https://api-dev.talkingstick.app/manager/',
  buildNumber: "29895674",  
  versionNumber: "3.4.3",  
  environment_deploy: 'dev',
  rayGunKey: 'o8ZvYYvyIkeYqwMB9tjiwA',
  authKey: '6f992617-848a-49b5-8800-948a13a7047f',
  cryptoKey: '7fb8c7f5-e4f0-4392-b350-8a521da61f89',
  hostname: '',
};
